/**
 * Shared results-count parser.
 *
 * Both `search_used` and `search_result_clicked` read the on-page results-count
 * element. They MUST agree on the value so a paired search -> click funnel is
 * consistent. This is the single source of truth for that parse.
 *
 * Returns `null` (not 0, not NaN) when the element is missing or the text holds
 * no parsable digits, so an unknown count is never confused with a real zero.
 */
export const parseResultsCount = (
  element: HTMLElement | null
): number | null => {
  if (!element) {
    return null;
  }

  const digits = (element.textContent || '').replace(/[^0-9]/g, '');
  if (digits === '') {
    return null;
  }

  const parsed = parseInt(digits, 10);
  return Number.isNaN(parsed) ? null : parsed;
};
